import React from 'react';
import ArrowDown from "../svg/ArrowUp";
import classnames from "classnames";
import "./ArrowBubble.scss";

const ArrowBubble = ({animate,size}) => {
	return (
		<div className="arrow-bubble">
			<div className="arrow-bubble__wrapper">
				<div
					className={classnames(
					"arrow-bubble__wrapper__inner",{
						"animate":animate,
					})}
					style={size && {width:size,height:size}}
				>
					<ArrowDown mainColor="#FFFFFF" />
				</div>
			</div>
		</div>

	);
};

export default ArrowBubble;